module.exports = __webpack_public_path__ + "img/marker-point-naranja-oscuro.f4f4bb0a.png";